declare const jQuery: any;
const $ = jQuery;

const ajaxAction = "supp-acc-delete-item";

const ajaxCall: Function = window["iw"].utils.ajaxCall;
const errorModal: Function = window["iw"].modal.errorModal;
const confirmModal: Function = window["iw"].modal.confirmModal;
const successModal: Function = window["iw"].modal.successModal;
const waitModal: Function = window["iw"].modal.waitModal;

export function initPostListDeleteButtons($main): void
{
    const $buttons = $main.find(".supplier-account-list [data-delete-post]");
    if ($buttons.length === 0)
    {
        return;
    }
    $buttons.on("click", function (event) {
        const $button = $(this);
        const postId = parseInt($button.attr("data-delete-post"));
        const postType = $button.attr("data-post-type");
        const postTitle = $button.attr("data-post-title") || "Untitled";
        const config: DeletePostConfig = {
            confirmMsg: `Are you sure you want to delete "${postTitle}"? This cannot be undone!`,
            successMsg: `You have successfully deleted "${postTitle}".`,
            postId,
            postType
        };
        const del = async () => {
            const deleted: boolean = await deletePost(config);
            if (deleted)
            {
                $button.closest("[data-supplier-post-list] > li").remove();
            }
        };
        del();
        return false;
    });
}

export interface DeletePostConfig 
{
    confirmMsg: string;
    successMsg: string;
    postId: number;
    postType: string;
}

export async function deletePost(config: DeletePostConfig): Promise<boolean>
{
    if (!await confirmModal(config.confirmMsg))
    {
        return false;
    }
    const data = {
        post_id: config.postId,
        post_type: config.postType
    };
    waitModal(`Deleting, please wait...`);
    try
    {
        const res = await ajaxCall(ajaxAction, data);
        if (!res?.ok)
        {
            console.error("Bad response:", res);
            throw new Error(`Bad server response`);
        }
        successModal(config.successMsg);
        return true;
    }
    catch (error)
    {
        errorModal("Failed to delete. Please try refreshing the page.");
        return false;
    }
}
